import { startCase } from 'lodash';

import { ButtonGroupInputOption } from '@/components/form/baseInputs/inputTypes';
import {
  NotificationKind,
  NotificationPreferenceEmailFrequency,
} from '@/types/schema';

// Column width constants for consistent layout
export const COLUMN_WIDTHS = {
  IN_APP: 50,
  EMAIL_FREQUENCY: 200,
} as const;

export const SYSTEM_NOTIFICATION_KINDS = [
  NotificationKind.UnmappedIntegrationAssetClasses,
];

// The server always sends these kinds in the app, because other features
// depend on them. The Tasks badge refreshes when a presentation approval
// request notification arrives.
export const REQUIRED_IN_APP_NOTIFICATION_KINDS: NotificationKind[] = [
  NotificationKind.PresentationApprovalRequested,
];

export const NOTIFICATION_KIND_ORDER = [
  NotificationKind.AiSuggestion,
  NotificationKind.AiSuggestionRegen,
  NotificationKind.DocumentSummary,
  NotificationKind.FormExtractionCompleted,
  NotificationKind.EstateInsightsGenerated,
  NotificationKind.PresentationGenerated,
  NotificationKind.PresentationApprovalRequested,
  NotificationKind.ProposalGenerated,
  NotificationKind.EstateSnapshotGenerated,
  NotificationKind.ManualAiDp,
];

export const NOTIFICATION_KIND_LABEL: Record<NotificationKind, string> = {
  [NotificationKind.AiSuggestion]: 'Data identified for review',
  [NotificationKind.AiSuggestionRegen]: 'AI suggestions regenerated',
  [NotificationKind.DocumentSummary]: 'Document summary generated',
  [NotificationKind.DocumentSummaryExported]: 'Document summary exported',
  [NotificationKind.FormExtractionCompleted]: 'Form extraction completed',
  [NotificationKind.PresentationGenerated]: 'Presentation PDF generated',
  [NotificationKind.PresentationApprovalRequested]:
    'Presentation review requested',
  [NotificationKind.ProposalGenerated]: 'Analysis PDF generated',
  [NotificationKind.EstateInsightsGenerated]: 'New insight identified',
  [NotificationKind.ManualAiDp]: 'Dispositions regenerated',
  [NotificationKind.UnmappedIntegrationAssetClasses]:
    'Unmapped integration asset classes',
  [NotificationKind.EstateSnapshotGenerated]:
    'Estate360 presentation generated',
  [NotificationKind.MemoGenerated]: 'Memo generated',
  [NotificationKind.MemoExported]: 'Memo exported',
  [NotificationKind.ValidationQuestions]: 'Validation questions ready',
};

// Option sx replaces the ButtonGroup default sx, so it must keep nowrap.
const EMAIL_FREQUENCY_BUTTON_PROPS = {
  sx: { whiteSpace: 'nowrap', px: 1 },
};

export const EMAIL_FREQUENCY_OPTIONS: ButtonGroupInputOption<
  NotificationPreferenceEmailFrequency | 'none'
>[] = [
  {
    value: 'none',
    display: 'Never',
    buttonProps: EMAIL_FREQUENCY_BUTTON_PROPS,
  },
  {
    value: NotificationPreferenceEmailFrequency.Immediate,
    display: 'Immediately',
    buttonProps: EMAIL_FREQUENCY_BUTTON_PROPS,
  },
  {
    value: NotificationPreferenceEmailFrequency.Daily,
    display: 'Daily',
    buttonProps: EMAIL_FREQUENCY_BUTTON_PROPS,
  },
];

export function getNotificationKindLabel(kind: NotificationKind): string {
  return NOTIFICATION_KIND_LABEL[kind] || startCase(kind.toLowerCase());
}
